import React from 'react';
import { Box, Divider, styled } from '@mui/material';
import {
    StyledModalClientSubtitles,
    StyledModalClientTitles,
    StyledColumnBox,
    StyledRowBox,
    StyledSquareImage
} from '../../theme/StyledElements';
import { getImageKitUrlFrom } from '../../utils';
import { BasketDetails } from '../../models/BasketDetails';

export const StyledDivider = styled(Divider)(() => ({
    borderColor: '#134C03',
    borderLeftWidth: 'medium',
    margin: '0px',
    height: '20px',
    marginLeft: '40px',
    borderRightWidth: 'inherit'
}));

interface BasketCardProps {
    item: BasketDetails;
    isPrimaryClient: boolean;
}

export function BasketCard({ item, isPrimaryClient }: BasketCardProps): React.ReactElement {
    return (
        <StyledColumnBox sx={{ flexDirection: isPrimaryClient ? 'column-reverse' : 'column' }}>
            <StyledDivider orientation="vertical" variant="middle" />
            <StyledRowBox>
                {item.basket.photoUrl &&
                    item.basket.photoUrl[0] &&
                    typeof item.basket.photoUrl[0] === 'string' && (
                        <StyledSquareImage src={getImageKitUrlFrom(item.basket.photoUrl[0])} />
                    )}
                <StyledColumnBox
                    sx={{
                        justifyContent: 'center'
                    }}>
                    <StyledModalClientTitles variant="body2">
                        <Box sx={{ marginRight: '10px' }}>{item.quantity}</Box>
                        <Box>{item.basket.titre}</Box>
                    </StyledModalClientTitles>
                    <StyledModalClientSubtitles variant="caption">
                        {item.basket.poids}kg
                    </StyledModalClientSubtitles>
                    <StyledModalClientTitles variant="body2">
                        {item.basket.prix?.toFixed(2)}€
                    </StyledModalClientTitles>
                </StyledColumnBox>
            </StyledRowBox>
        </StyledColumnBox>
    );
}
